export const propertiesToCopy = [
  "fontFamily",
  "fontSize",
  "fontWeight",
  "lineHeight",
  "padding",
  "paddingLeft",
  "paddingRight",
  "paddingTop",
  "paddingBottom",
  "boxSizing",
];
